import { nanoid } from "@reduxjs/toolkit";

import shoes1 from "../../../../assets/HomeShoes/runningShoes/shoes1.png";
import shoes11 from "../../../../assets/HomeShoes/runningShoes/shoes11.png";
import shoes12 from "../../../../assets/HomeShoes/runningShoes/shoes12.png";
import shoes13 from "../../../../assets/HomeShoes/runningShoes/shoes13.png";

import shoes2 from "../../../../assets/HomeShoes/runningShoes/shoes2.png";
import shoes21 from "../../../../assets/HomeShoes/runningShoes/shoes21.png";
import shoes22 from "../../../../assets/HomeShoes/runningShoes/shoes22.png";
import shoes23 from "../../../../assets/HomeShoes/runningShoes/shoes23.png";

import shoes3 from "../../../../assets/HomeShoes/runningShoes/shoes3.png";

import shoes4 from "../../../../assets/HomeShoes/runningShoes/shoes4.png";
import shoes41 from "../../../../assets/HomeShoes/runningShoes/shoes41.png";
import shoes42 from "../../../../assets/HomeShoes/runningShoes/shoes42.png";
import shoes43 from "../../../../assets/HomeShoes/runningShoes/shoes43.png";

import shoes5 from "../../../../assets/HomeShoes/runningShoes/shoes5.png";
import shoes51 from "../../../../assets/HomeShoes/runningShoes/shoes51.png";
import shoes52 from "../../../../assets/HomeShoes/runningShoes/shoes52.png";
import shoes53 from "../../../../assets/HomeShoes/runningShoes/shoes53.png";

import shoes6 from "../../../../assets/HomeShoes/runningShoes/shoes6.png";
import shoes61 from "../../../../assets/HomeShoes/runningShoes/shoes61.png";
import shoes62 from "../../../../assets/HomeShoes/runningShoes/shoes62.png";
import shoes63 from "../../../../assets/HomeShoes/runningShoes/shoes63.png";

import shoes7 from "../../../../assets/HomeShoes/runningShoes/shoes7.png";
import shoes71 from "../../../../assets/HomeShoes/runningShoes/shoes71.png";
import shoes72 from "../../../../assets/HomeShoes/runningShoes/shoes72.png";
import shoes73 from "../../../../assets/HomeShoes/runningShoes/shoes73.png";

import shoes8 from "../../../../assets/HomeShoes/runningShoes/shoes8.png";
import shoes81 from "../../../../assets/HomeShoes/runningShoes/shoes81.png";
import shoes82 from "../../../../assets/HomeShoes/runningShoes/shoes82.png";
import shoes83 from "../../../../assets/HomeShoes/runningShoes/shoes83.png";

import shoes9 from "../../../../assets/HomeShoes/runningShoes/shoes9.png";
import shoes91 from "../../../../assets/HomeShoes/runningShoes/shoes91.png";
import shoes92 from "../../../../assets/HomeShoes/runningShoes/shoes92.png";
import shoes93 from "../../../../assets/HomeShoes/runningShoes/shoes93.png";

export const MenRunningShoesData = [
  {
    id: nanoid(),
    image: shoes1,
    title: "Retaliate 2 Hyperwave Unisex Unisex Running Shoes",
    price: 3569,
    offer: "10% discount on prepaid order",
    button: "Add To Cart",
    color: "Navy-Speed Green-Inky Blue-PUMA Black",
    size: "Uk 7",
    qty: 1,
    checked: false,
    description:
      "Set the foundation for a great workout with the PWRFRAME TR 2. It has a new, improved upper over v1 and PWRFRAME technology",

    returns:
      "Free return for all qualifying orders within 14 days of your order delivery date. Visit our Return Policy for more information. For any queries, please contact Customer Service at 1111002255 or via customercare@india.com",
    productStory:
      "Set the foundation for a great workout with the PWRFRAME TR 2. It has a new, improved upper over v1 and PWRFRAME technology in the forefoot that provides support and stability through explosive movement.",

    detail: [
      {
        id: nanoid(),
        point: "Textile upper",
      },
      {
        id: nanoid(),
        point: "Responsive midsole",
      },
      {
        id: nanoid(),
        point: "PUMA Formstrip on the medial and lateral sides",
      },
    ],
    manufacturer: [
      {
        id: nanoid(),
        point: "VMC Royal Co.Ltd.",
      },
      {
        id: nanoid(),
        point:
          "VN SAO VIET CORPORATION BINH DUONG PROVINCE  4 ROAD, DONG AN INDUSTRIAL HO CHI MINH BINH DUONG PROVINCE THUAN AN CITY",
      },
    ],
    cardImages: [
      {
        id: nanoid(),
        imgCard: shoes1,
      },
      {
        id: nanoid(),
        imgCard: shoes11,
      },
      {
        id: nanoid(),
        imgCard: shoes12,
      },
      {
        id: nanoid(),
        imgCard: shoes13,
      },
    ],
  },
  {
    id: nanoid(),
    image: shoes2,
    title: "Retaliate 2 Hyperwave Unisex Unisex Running Shoes",
    price: 3249,
    offer: "10% discount on prepaid order",
    button: "Add To Cart",
    color: "PUMA Black-Cool Dark Gray",
    size: "Uk 7",
    qty: 1,
    checked: false,
    description:
      "Set the foundation for a great workout with the PWRFRAME TR 2. It has a new, improved upper over v1 and PWRFRAME technology",

    returns:
      "Free return for all qualifying orders within 14 days of your order delivery date. Visit our Return Policy for more information. For any queries, please contact Customer Service at 1111002255 or via customercare@india.com",
    productStory:
      "Set the foundation for a great workout with the PWRFRAME TR 2. It has a new, improved upper over v1 and PWRFRAME technology in the forefoot that provides support and stability through explosive movement.",

    detail: [
      {
        id: nanoid(),
        point: "Textile upper",
      },
      {
        id: nanoid(),
        point: "Responsive midsole",
      },
      {
        id: nanoid(),
        point: "PUMA Formstrip on the medial and lateral sides",
      },
    ],
    manufacturer: [
      {
        id: nanoid(),
        point: "VMC Royal Co., Ltd.",
      },
      {
        id: nanoid(),
        point:
          "VN SAO VIET CORPORATION BINH DUONG PROVINCE 4 ROAD, DONG AN INDUSTRIAL HO CHI MINH BINH DUONG PROVINCE THUAN AN CITY",
      },
    ],

    cardImages: [
      {
        id: nanoid(),
        imgCard: shoes2,
      },
      {
        id: nanoid(),
        imgCard: shoes21,
      },
      {
        id: nanoid(),
        imgCard: shoes22,
      },
      {
        id: nanoid(),
        imgCard: shoes23,
      },
    ],
  },
  {
    id: nanoid(),
    image: shoes3,
    title: "ForeverRUN NITRO Men's Running Shoes",
    price: 16999,
    offer: "10% discount on prepaid order",
    button: "Add To Cart",
    color: "PUMA Black-Green Gecko",
    size: "Uk 7",
    qty: 1,
    checked: false,
    description:
      "The ForeverRun NITRO dawns a new era of support and guidance for all runners, providing the softness of a full NITRO midsole",

    returns:
      "Free return for all qualifying orders within 14 days of your order delivery date. Visit our Return Policy for more information. For any queries, please contact Customer Service at 1111002255 or via customercare@india.com",
    productStory:
      "The ForeverRun NITRO dawns a new era of support and guidance for all runners, providing the softness of a full NITRO midsole without compromising stability. It features a newly developed NITRO midsole with two different densities – a softer core with a firmer rim – and an asymmetrical heel counter to hold the foot in place through every stride. The theme also continues on the outsole, thanks to a wider medial rubber segment stabilising late-stage pronation. In short, it's the perfect blend of support and cushion.",

    detail: [
      {
        id: nanoid(),
        point: "Low boot",
      },
      {
        id: nanoid(),
        point: "Engineered mesh upper for support",
      },
      {
        id: nanoid(),
        point: "PWRTAPE reinforcement for upper",
      },
      {
        id: nanoid(),
        point:
          "Asymmetrical heel counter stabilises the foot at impact and early pronation",
      },
      {
        id: nanoid(),
        point: "NITRO foam midsole",
      },
      {
        id: nanoid(),
        point:
          "RUNGUIDE system promotes proper alignment and keeps the foot centred through each stride",
      },
      {
        id: nanoid(),
        point: "PUMAGRIP rubber outsole",
      },
      {
        id: nanoid(),
        point: "Medial flare for wider foot support",
      },
    ],
    manufacturer: [
      {
        id: nanoid(),
        point: "SAO VIET CORPORATION",
      },
      {
        id: nanoid(),
        point:
          "VN BINH DUONG PROVINCE 4 ROAD, DONG AN INDUSTRIAL ZONE, THUAN AN CITY BINH DUONG PROVINCE THUAN AN CITY",
      },
    ],
    cardImages: [
      {
        id: nanoid(),
        imgCard: shoes3,
      },
      {
        id: nanoid(),
        imgCard: shoes3,
      },
      {
        id: nanoid(),
        imgCard: shoes3,
      },
      {
        id: nanoid(),
        imgCard: shoes3,
      },
    ],
  },
  {
    id: nanoid(),
    image: shoes4,
    title: "ForeverRUN NITRO Men's Running Shoes",
    price: 16999,
    offer: "10% discount on prepaid order",
    button: "Add To Cart",
    color: "PUMA White-Green Gecko",
    size: "Uk 7",
    qty: 1,
    checked: false,
    description:
      "The ForeverRun NITRO dawns a new era of support and guidance for all runners, providing the softness of a full NITRO midsole",

    returns:
      "Free return for all qualifying orders within 14 days of your order delivery date. Visit our Return Policy for more information. For any queries, please contact Customer Service at 1111002255 or via customercare@india.com",
    productStory:
      "The ForeverRun NITRO dawns a new era of support and guidance for all runners, providing the softness of a full NITRO midsole without compromising stability. It features a newly developed NITRO midsole with two different densities – a softer core with a firmer rim – and an asymmetrical heel counter to hold the foot in place through every stride. The theme also continues on the outsole, thanks to a wider medial rubber segment stabilising late-stage pronation. In short, it's the perfect blend of support and cushion.",

    detail: [
      {
        id: nanoid(),
        point: "Engineered mesh upper for support",
      },
      {
        id: nanoid(),
        point: "PWRTAPE reinforcement for upper",
      },
      {
        id: nanoid(),
        point:
          "Asymmetrical heel counter stabilises the foot at impact and early pronation",
      },
      {
        id: nanoid(),
        point: "NITRO foam midsole",
      },
      {
        id: nanoid(),
        point:
          "RUNGUIDE system promotes proper alignment and keeps the foot centred through each stride",
      },
      {
        id: nanoid(),
        point: "PUMAGRIP rubber outsole",
      },
      {
        id: nanoid(),
        point: "Medial flare for wider foot support",
      },
    ],

    manufacturer: [
      {
        id: nanoid(),
        point: "SAO VIET CORPORATION",
      },
      {
        id: nanoid(),
        point:
          "VN BINH DUONG PROVINCE 4 ROAD, DONG AN INDUSTRIAL ZONE, THUAN AN CITY BINH DUONG PROVINCE THUAN AN CITY",
      },
    ],
    cardImages: [
      {
        id: nanoid(),
        imgCard: shoes4,
      },
      {
        id: nanoid(),
        imgCard: shoes41,
      },
      {
        id: nanoid(),
        imgCard: shoes42,
      },
      {
        id: nanoid(),
        imgCard: shoes43,
      },
    ],
  },
  {
    id: nanoid(),
    image: shoes5,
    title: "ForeverRUN NITRO Men's Running Shoes",
    price: 16999,
    offer: "10% discount on prepaid order",
    button: "Add To Cart",
    color: "PUMA White-Green Gecko",
    size: "Uk 7",
    qty: 1,
    checked: false,
    description:
      "An all-in-one neutral running shoe for any distance, the Velocity NITRO 2 First Mile is a lightweight and stylish addition to the Run",

    returns:
      "Free return for all qualifying orders within 14 days of your order delivery date. Visit our Return Policy for more information. For any queries, please contact Customer Service at 1111002255 or via customercare@india.com",
    productStory:
      "An all-in-one neutral running shoe for any distance, the Velocity NITRO 2 First Mile is a lightweight and stylish addition to the Run PUMA roster. The consciously cool upper is crafted from at least 20% recycled material, while NITRO™ foam offers exceptional responsiveness and ultimate cushioning. Built for comfort at whatever speed, this upgrade to the original is a well-fitting and durable shoe for a smooth ride. Plus, PUMAGRIP provides multi-surface traction—from treadmill to track. Versatility never looked (or felt) this good",

    detail: [
      {
        id: nanoid(),
        point: "Engineered mesh upper for support",
      },
      {
        id: nanoid(),
        point: "Great forefoot grip",
      },
      {
        id: nanoid(),
        point: "Midfoot stability",
      },
      {
        id: nanoid(),
        point: "Decoupled heel",
      },
      {
        id: nanoid(),
        point: "Heel-to-toe drop: 8mm",
      },
      {
        id: nanoid(),
        point: "NITRO™ midsole",
      },
      {
        id: nanoid(),
        point: "PUMAGRIP rubber outsole for multi-surface traction",
      },
      {
        id: nanoid(),
        point: "Reflective design elements",
      },
      {
        id: nanoid(),
        point: "PUMA Formstrip on side",
      },
    ],

    manufacturer: [
      {
        id: nanoid(),
        point: "Putian Xinlong Footwear Co.Ltd",
      },

      {
        id: nanoid(),
        point: "FCNXF Fujian Shuinan Village Huangshi Town 351144 PUTIAN",
      },
    ],
    cardImages: [
      {
        id: nanoid(),
        imgCard: shoes5,
      },
      {
        id: nanoid(),
        imgCard: shoes51,
      },
      {
        id: nanoid(),
        imgCard: shoes52,
      },
      {
        id: nanoid(),
        imgCard: shoes53,
      },
    ],
  },
  {
    id: nanoid(),
    image: shoes6,
    title: "PUMA x FIRST MILE Velocity NITRO 2 Men's Running Shoes",
    price: 10399,
    offer: "10% discount on prepaid order",
    button: "Add To Cart",
    color: "Alpine Snow-Cool Dark Gray-Astro Red",
    size: "Uk 7",
    qty: 1,
    checked: false,
    description:
      "Get ready to conquer the track in style with the PUMA Fast Wanderer Men's Running Shoes. The lightweight textile upper",

    returns:
      "Free return for all qualifying orders within 14 days of your order delivery date. Visit our Return Policy for more information. For any queries, please contact Customer Service at 1111002255 or via customercare@india.com",
    productStory:
      "Get ready to conquer the track in style with the PUMA Fast Wanderer Men's Running Shoes. The lightweight textile upper with cushioned midsole will have you turning heads as you breeze past your competition. With a durable outsole, these shoes will keep you running for miles.",

    detail: [
      {
        id: nanoid(),
        point: "Low boot",
      },
      {
        id: nanoid(),
        point: "Textile upper",
      },
      {
        id: nanoid(),
        point: "Lace closure",
      },
      {
        id: nanoid(),
        point: "EVA outsole",
      },
      {
        id: nanoid(),
        point: "Heel type: Flat",
      },
      {
        id: nanoid(),
        point: "Shoe width: Regular fit",
      },
      {
        id: nanoid(),
        point: "Heel-to-toe-drop: 12 mm",
      },
      {
        id: nanoid(),
        point: "Shoe pronation: Neutral",
      },
      {
        id: nanoid(),
        point: "Ideal for road and treadmill running",
      },
      {
        id: nanoid(),
        point: "PUMA Formstrip on lateral side",
      },
    ],

    manufacturer: [
      {
        id: nanoid(),
        point: "MOCHIKO SHOES PRIVATE LIMITED",
      },
      {
        id: nanoid(),
        point:
          "IN UTTRAKHAND KHASRA NO 3914, MOUZA MAZRI GRANT, LAL TAPPER INDUSTRIAL AREA, NH-72 248140 DEHRADUN",
      },
    ],
    cardImages: [
      {
        id: nanoid(),
        imgCard: shoes6,
      },
      {
        id: nanoid(),
        imgCard: shoes61,
      },
      {
        id: nanoid(),
        imgCard: shoes62,
      },
      {
        id: nanoid(),
        imgCard: shoes63,
      },
    ],
  },
  {
    id: nanoid(),
    image: shoes7,
    title: "PUMA Fast Wanderer Men's Running Shoes",
    price: 2159,
    offer: "10% discount on prepaid order",
    button: "Add To Cart",
    color: "Navy Blazer-PUMA Black-Strong Red",
    size: "Uk 7",
    qty: 1,
    checked: false,
    description:
      "Get ready to conquer the track in style with the PUMA Fast Wanderer Men's Running Shoes. The lightweight textile upper",

    returns:
      "Free return for all qualifying orders within 14 days of your order delivery date. Visit our Return Policy for more information. For any queries, please contact Customer Service at 1111002255 or via customercare@india.com",
    productStory:
      "Get ready to conquer the track in style with the PUMA Fast Wanderer Men's Running Shoes. The lightweight textile upper with cushioned midsole will have you turning heads as you breeze past your competition. With a durable outsole, these shoes will keep you running for miles.",

    detail: [
      {
        id: nanoid(),
        point: "Low boot",
      },
      {
        id: nanoid(),
        point: "Textile upper",
      },
      {
        id: nanoid(),
        point: "Lace closure",
      },
      {
        id: nanoid(),
        point: "EVA outsole",
      },
      {
        id: nanoid(),
        point: "Heel type: Flat",
      },
      {
        id: nanoid(),
        point: "Shoe width: Regular fit",
      },
      {
        id: nanoid(),
        point: "Heel-to-toe-drop: 12 mm",
      },
      {
        id: nanoid(),
        point: "Shoe pronation: Neutral",
      },
      {
        id: nanoid(),
        point: "Ideal for road and treadmill running",
      },
      {
        id: nanoid(),
        point: "PUMA Formstrip on lateral side",
      },
    ],

    manufacturer: [
      {
        id: nanoid(),
        point: "MOCHIKO SHOES PRIVATE LIMITED",
      },
      {
        id: nanoid(),
        point:
          "IN UTTRAKHAND KHASRA NO 3914, MOUZA MAZRI GRANT, LAL TAPPER INDUSTRIAL AREA, NH-72 248140 DEHRADUN",
      },
    ],
    cardImages: [
      {
        id: nanoid(),
        imgCard: shoes7,
      },
      {
        id: nanoid(),
        imgCard: shoes71,
      },
      {
        id: nanoid(),
        imgCard: shoes72,
      },
      {
        id: nanoid(),
        imgCard: shoes73,
      },
    ],
  },

  {
    id: nanoid(),
    image: shoes8,
    title: "PUMA Fast Wanderer Men's Running Shoes",
    price: 2159,
    offer: "10% discount on prepaid order",
    button: "Add To Cart",
    color: "Dark Coal-PUMA Black-Puma Silver-Rickie Orange",
    size: "Uk 7",
    qty: 1,
    checked: false,
    description:
      "Get ready to conquer the track in style with the PUMA Fast Wanderer Men's Running Shoes. The lightweight textile upper",

    returns:
      "Free return for all qualifying orders within 14 days of your order delivery date. Visit our Return Policy for more information. For any queries, please contact Customer Service at 1111002255 or via customercare@india.com",
    productStory:
      "Get ready to conquer the track in style with the PUMA Fast Wanderer Men's Running Shoes. The lightweight textile upper with cushioned midsole will have you turning heads as you breeze past your competition. With a durable outsole, these shoes will keep you running for miles.",

    detail: [
      {
        id: nanoid(),
        point: "Low boot",
      },
      {
        id: nanoid(),
        point: "Textile upper",
      },
      {
        id: nanoid(),
        point: "Lace closure",
      },
      {
        id: nanoid(),
        point: "EVA outsole",
      },
      {
        id: nanoid(),
        point: "Heel type: Flat",
      },
      {
        id: nanoid(),
        point: "Shoe width: Regular fit",
      },
      {
        id: nanoid(),
        point: "Heel-to-toe-drop: 12 mm",
      },
      {
        id: nanoid(),
        point: "Shoe pronation: Neutral",
      },
      {
        id: nanoid(),
        point: "Ideal for road and treadmill running",
      },
      {
        id: nanoid(),
        point: "PUMA Formstrip on lateral side",
      },
    ],

    manufacturer: [
      {
        id: nanoid(),
        point: "MOCHIKO SHOES PRIVATE LIMITED",
      },
      {
        id: nanoid(),
        point:
          "IN UTTRAKHAND KHASRA NO 3914, MOUZA MAZRI GRANT, LAL TAPPER INDUSTRIAL AREA, NH-72 248140 DEHRADUN",
      },
    ],
    cardImages: [
      {
        id: nanoid(),
        imgCard: shoes8,
      },
      {
        id: nanoid(),
        imgCard: shoes81,
      },
      {
        id: nanoid(),
        imgCard: shoes82,
      },
      {
        id: nanoid(),
        imgCard: shoes83,
      },
    ],
  },
  {
    id: nanoid(),
    image: shoes9,
    title: "Hybrid Fuego Women's Running Shoes",
    price: 3709,
    offer: "10% discount on prepaid order",
    button: "Add To Cart",
    color: "Puma White-Pink Alert-Yellow Alert",
    size: "Uk 7",
    qty: 1,
    checked: false,
    description:
      "Bold street style meets modern technology in the dynamic HYBRID Fuego women's sneaker. This game-changing design",

    returns:
      "Free return for all qualifying orders within 14 days of your order delivery date. Visit our Return Policy for more information. For any queries, please contact Customer Service at 1111002255 or via customercare@india.com",
    productStory:
      "Bold street style meets modern technology in the dynamic Hybrid Fuego Women's Running Shoes. This game-changing design features a bold colour-blocked upper with overlays at the heel and a classic design for a sleek look",

    detail: [
      {
        id: nanoid(),
        point: "Heel type: Flat",
      },
      {
        id: nanoid(),
        point: "Shoe width: Regular fit",
      },
      {
        id: nanoid(),
        point: "Shoe pronation: Neutral",
      },
      {
        id: nanoid(),
        point: "Heel-to-toe-drop: 12 mm",
      },
      {
        id: nanoid(),
        point: "Suitable for an average distance of upto 500 km",
      },
      {
        id: nanoid(),
        point: "Ideal for Road & Treadmill Running",
      },
    ],

    manufacturer: [
      {
        id: nanoid(),
        point: "SAO VIET CORPORATION",
      },
      {
        id: nanoid(),
        point:
          "VN BINH DUONG PROVINCE 4 ROAD, DONG AN INDUSTRIAL ZONE, THUAN AN CITY BINH DUONG PROVINCE THUAN AN CITY",
      },
    ],
    cardImages: [
      {
        id: nanoid(),
        imgCard: shoes9,
      },
      {
        id: nanoid(),
        imgCard: shoes91,
      },
      {
        id: nanoid(),
        imgCard: shoes92,
      },
      {
        id: nanoid(),
        imgCard: shoes93,
      },
    ],
  },
];
